import { create } from 'zustand';
import { ICampaign } from '../../types/cases';

// TO DO update ICaseDetail and use it

type State = {
    caseData: any;
    campaignsNames: ICampaign[];
    isTestCase: boolean;
    referral_status: string;
    status: string;
    isBrandedPhoneExperimentEnabled: boolean;
    isPhoneNumberDialogEnabled: boolean;
    isActionsDisabled: boolean;
    isReadOnly: boolean;
    isTwilioWidgetOpen: boolean;
    isAnsweringCalls: boolean;
};

type Action = {
    setCaseData: (name: State['caseData']) => void;
    setCampaignsNames: (name: State['campaignsNames']) => void;
    setIsTestCase: (name: State['isTestCase']) => void;
    setReferralStatus: (name: State['referral_status']) => void;
    setStatus: (name: State['status']) => void;
    setIsBrandedPhoneExperimentEnabled: (name: State['isBrandedPhoneExperimentEnabled']) => void;
    setIsPhoneNumberDialogEnabled: (name: State['isPhoneNumberDialogEnabled']) => void;
    setIsActionsDisabled: (name: State['isActionsDisabled']) => void;
    setIsReadOnly: (name: State['isReadOnly']) => void;
    setIsTwilioWidgetOpen: (isOpen: State['isTwilioWidgetOpen']) => void;
    setIsAnsweringCalls: (isOpen: State['isAnsweringCalls']) => void;
};

export const useBoard = create<State & Action>((set) => ({
    caseData: {},
    campaignsNames: [],
    isTestCase: false,
    status: '',
    referral_status: '',
    isBrandedPhoneExperimentEnabled: false,
    isPhoneNumberDialogEnabled: false,
    isActionsDisabled: false,
    isReadOnly: false,
    isTwilioWidgetOpen: false,
    isAnsweringCalls: false,
    setCaseData: (caseData) => set({ caseData: caseData }),
    setCampaignsNames: (campaignsNames) => set({ campaignsNames: campaignsNames }),
    setIsTestCase: (isTestCase) => set({ isTestCase: isTestCase }),
    setStatus: (status) => set({ status: status }),
    setReferralStatus: (referral_status) => set({ referral_status: referral_status }),
    setIsBrandedPhoneExperimentEnabled: (isBrandedPhoneExperimentEnabled) =>
        set({ isBrandedPhoneExperimentEnabled: isBrandedPhoneExperimentEnabled }),
    setIsPhoneNumberDialogEnabled: (isPhoneNumberDialogEnabled) =>
        set({ isPhoneNumberDialogEnabled: isPhoneNumberDialogEnabled }),
    setIsActionsDisabled: (isActionsDisabled) => set({ isActionsDisabled: isActionsDisabled }),
    setIsReadOnly: (isReadOnly) => set({ isReadOnly: isReadOnly }),
    setIsTwilioWidgetOpen: (isTwilioWidgetOpen) => set({ isTwilioWidgetOpen }),
    setIsAnsweringCalls: (isAnsweringCalls) => set({ isAnsweringCalls })
}));
